<template>
    <div name="add-id" class="add-id">
        <close-button 
            @close="onClose"
        />
        <img src="../../../assets/revisit_contract_step_3.png" class="step" />
        <span class="title">신분증 사본을 제출해 주세요</span>
        <span class="text1">신청을 하는 사람의 신분증 사본</span>
        <span class="text2">환자 본인 또는 신청을 대리하는 가족/법정 대리인</span>
        <div v-if="!delegateWithAddition.id_card_file" class="file-upload" style="margin-top: 16px;margin-bottom: 20px; margin-left: -10px;">
            <input type="file" ref="fileInput" @change="handleFileChange" hidden accept="image/*" />
            <img src="../../../assets/upload.png" @click="triggerFileInput" style="width: 50%;" />
            <button class="upload-button" @click="triggerFileInput">첨부하기</button>
        </div>
        <div class="uploaded-box" v-else>
            <span>{{ delegateWithAddition.id_card_file.name }}</span>
            <img @click="deleteFile" class="delete" src="../../../assets/delete.png" />
        </div>
        <div class="info-box" v-if="!delegateWithAddition.id_card_file">
            <div class="info-box-row">
                <img style="width: 22px;" src="../../../assets/dot.png" />
                <span class="info-box-text">어두운 배경 위에서 촬영하세요</span>
            </div>
            <div class="info-box-row">
                <img style="width: 22px;" src="../../../assets/dot.png" />
                <span class="info-box-text">빛이 반사되지 않도록 주의하세요</span>
            </div>
            <div class="info-box-row">
                <img style="width: 22px;" src="../../../assets/dot.png" />
                <span class="info-box-text">주민등록증 또는 운전면허증 외 다른 사본 제출 시 접수 반려돼요</span>
            </div>
        </div>
        <div style="height: 180px;">

        </div>
        <div class="footer-button-area">
            <span class="error" v-if="isError">신분증 사본을 필수로 제출해 주세요</span>
            <div class="buttons" style="margin-top: 8px;">
                <button class="button1" @click="prev">이전</button>
                <button class="button2" @click="next">첨부완료</button>
            </div>
        </div>

    </div>
</template>

<script>
import CloseButton from '@/components/atoms/CloseButton';
import {mapState} from 'vuex';
export default {
    name: 'addId',
    computed: mapState(['delegateWithAddition', 'pre_delegation_info', 'draftProfile']),
    components: {
        CloseButton
    },
    data: function()
    {
        return {
            // uploadFile: null,
            isError: false
        }
    },
    mounted: function()
    {
        this.topFunction();
    },
    methods: {
        topFunction: function() {
            document.body.scrollTop = 0; // For Safari
            document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
        }, 
        prev: function()
        {
            this.$emit('prev', 2)
        },
        next: function()
        {
            if(this.delegateWithAddition.id_card_file === null)
            {
                this.isError = true
                return;
            }
            this.$emit('next', 4)
        },
        onClose: function()
        {
            this.$emit('onClose');
        },
        // file
        triggerFileInput() {
            this.$refs.fileInput.click();
            this.isError = false;
        },
        handleFileChange(event) {
            const file = event.target.files[0];
           
            const fileSplit = file.name.split(".");
           
          
           
            let filename = "";

            
            if(fileSplit.length > 1)
            {
                const filetype = fileSplit[fileSplit.length - 1]; 
                filename = this.delegateWithAddition.writer_type == 0 ?  `id_${this.draftProfile.name}_본인.${filetype}` : `id_${this.draftProfile.name}_${this.convertRelation(this.delegateWithAddition.writer_relationship)}.${filetype}`;
            }
            else
            {
                filename = file.name;
            }
            
            const file_new = new File(["content"], file.name, { type: file.type });
            const renamedFile = this.renameFile(file, filename);


            if (file) {
                console.log(`Selected file: ${file.name} new: ${filename}`);
            }

            this.delegateWithAddition.id_card_file = renamedFile;
  
        },
        renameFile: function (originalFile, newFileName) {
            return new File([originalFile], newFileName, {
                type: originalFile.type,
                lastModified: originalFile.lastModified
            });
        },

        convertRelation: function(relation)
        {
            if(relation === 0)
            {
                return '아버지'
            }
            else if(relation === 1)
            {
                return '어머니'
            }
            else if(relation === 2)
            {
                return '자녀'
            }
            else if(relation === 3)
            {
                return '손자'
            }
            else if(relation === 4)
            {
                return '손녀'
            }
            else if(relation === 5)
            {
                return '기타'
            }
        },
        deleteFile: function()
        {
            this.delegateWithAddition.id_card_file = null;
        }
        //file
    }
}
</script>

<style scoped>
    .add-id {
        width: 100%;
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        flex-direction: column;
        box-sizing: border-box;
        padding: 16px;
    }

    @media (min-width: 600px) {
        .add-id {
            width: 600px;
            display: flex;
            justify-content: flex-start;
            align-items: flex-start;
            flex-direction: column;
            box-sizing: border-box;
            padding: 15px;
        }
    }
    .footer-button-area {
        position: fixed;
        bottom: 0;
        width: 100%;
        background: linear-gradient(0deg, #FFF 0%, rgba(255, 255, 255, 0.00) 255.33%);
        z-index: 9999;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 10px 16px 28px 16px;
        box-sizing: border-box;
        margin-left: -16px;
    }

    @media (min-width: 600px) {
        .footer-button-area {
            width: 600px;
        }
    }

    /* header */
    .step {
        width: 100%;
        max-width: 600px;
    }
    .title {
        color: var(--Gray-100, #1E1E1E);
        font-family: Pretendard;
        font-size: 24px;
        font-style: normal;
        font-weight: 600;
        line-height: 26px; /* 108.333% */
        margin-top: 30px;
    }
    .text1 {
        color: #184FA1;
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: 22px; /* 122.222% */
        margin-top: 16px;
    }
    .text2 {
        color: var(--Gray-60, #6B7684);
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: 22px; /* 122.222% */
        margin-top: 4px;
    }
    /* header */

    /* file upload */
    .file-upload {
        display: inline-block;
        border-radius: 6px;
        padding: 6px 16px;
        width: 100%;
        text-align: center;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        margin-top: 20px;
    }
    .upload-button {
        display: flex;
        height: 47px;
        justify-content: center;
        align-items: center;
        /* width: 97px; */
        padding: 0px 16.535px 0px 17.465px;
        border-radius: 30px;
        background: var(--Gray-20, #F3F5F8);
        cursor: pointer;
        color: #184FA1;
        text-align: center;
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 500;
        line-height: 17px; /* 94.444% */
        border: 0;
        margin-top: 20px;
    }   
    /* info-box */
    .info-box {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        border-radius: 6px;
        background: var(--Gray-20, #F3F5F8);
        padding: 6px 20px;
        box-sizing: border-box;
    }
    .info-box-row {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        width: 100%;
    }
    .info-box-text {
        color: var(--Gray-60, #6B7684);
        font-family: Pretendard;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 18px; /* 128.571% */
    }
    /* error */
    .error {
        color: var(--Semantic-01_Red, #FF000F);
    font-family: Pretendard;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px; /* 157.143% */
        width: 100%;
        text-align: center;
    }
    /* buttons */
    .buttons {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .button1{
        height: 56px;
        flex-shrink: 0;
        border-radius: 6px;
        background: var(--Gray-20, #F3F5F8);
        width: 48%;
        max-width: 247px;
        display: flex;
        justify-content: center;
        align-items: center;
        border: 0;
        cursor: pointer;
        color: var(--Gray-100, #1E1E1E);
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }
    .button2 {
        height: 56px;
        flex-shrink: 0;
        border-radius: 6px;
        background: var(--Gray-100, #1E1E1E);
        width: 48%;
        max-width: 247px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        border: 0;
        color: var(--Gray-primary-color2, #FFF);
        text-align: center;
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }

    .uploaded-box {
        display: flex;
        width: 100%;
        height: 48px;
        padding: 0 16px;
        align-items: center;
        gap: 10px;
        flex-shrink: 0;
        box-sizing: border-box;
        border-radius: 6px;
        border: 1px solid var(--gray-40-button-stroke, #D1D6DB);
        background: var(--Gray-00, #FFF);
        display: flex;
        justify-content: space-between;
        align-items: center;
        color: var(--Gray-100, #1E1E1E);
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        margin-top: 20px;
    }
    .delete {
        width: 22px
    }
</style>


// WEBPACK FOOTER //
// src/components/organisms/revisit_contract/AddId.vue